export const footer = {
    copyright: "© 2026 Qease. All rights reserved.",
    description: "Antrian klinik digital yang membantu mempermudah pengelolaan antrian pasien agar pelayanan kesehatan menjadi lebih tertib, cepat, dan nyaman.",
    logo: {
        src: "./qease-logo.png",
        alt: "Qease Logo",
    },
    links: [
        { label: "FITUR", href: "#features" },
        { label: "PAKET", href: "#pricing" },
        { label: "TESTIMONI", href: "#testimonials" },
        { label: "FAQs", href: "#faqs" },
        { label: "KONTAK", href: "#contact" },
    ],
    social: [
        {
            icon: "tabler:brand-x",
            url: "#",
        },
        {
            icon: "tabler:brand-github",
            url: "#",
        },
        {
            icon: "tabler:brand-linkedin",
            url: "#",
        },
    ],
};
